import { Col, Form, Input, Row } from 'ui';

export type JoinedCommunitiesListFiltersFormValues = {
  search?: string;
};

const JoinedCommunitiesListFilters = () => (
  <Row>
    <Col span={24}>
      <Form.Item<JoinedCommunitiesListFiltersFormValues> label="Search" name="search">
        <Input hasSearch />
      </Form.Item>
    </Col>
  </Row>
);

export default JoinedCommunitiesListFilters;
